import template from './sso.html';
import controller from './sso.controller';

let ssoComponent = {
  restrict: 'E',
  bindings: {},
  transclude:true,
  template,
  controller,
  controllerAs: 'vm'
};

export default ssoComponent;



// WEBPACK FOOTER //
// ./app/common/sso/sso.component.js